Bingo.PhoneField = {};

Bingo.PhoneField.init = ($inputs) => {
    $inputs.each(function () {
        const $input = $(this);
        const proxyName = `${$input.attr('name')}_proxy`;
        if ($input.parent().find(`[name="${proxyName}"]`).length) {
            return;
        }

        // create proxy
        let proxy = $input.clone();
        proxy.attr('id', null);
        proxy.attr('data-nette-rules', null);
        proxy.type = 'text';
        proxy.attr('name', proxyName);
        // install it
        $input.parent()
            .prepend(proxy);
        $input.removeAttr('placeholder'); // this prevent IE to submit value of placeholder when field is empty
        $input.attr('type', 'hidden');
        $input.attr('tabindex', '-1');
        // ensure that focusing hidden field focus the proxy field
        $input.focus(() => {
            $input.focusout();
            $(proxy).focus();
        });
        proxy = $(proxy);
        //  Phone input init
        proxy.closest('.js-textField')
            .addClass('-phone');
        proxy.intlTelInput({
            autoPlaceholder: 'polite',
            preferredCountries: ['lu'],
            formatOnDisplay: false,
            utilsScript: '/src/js/separated/utils.js',
        });
        const textField = proxy.closest('.js-textField');
        const dropdown = textField.find('.iti__country-list');
        if (textField.width() > 250) {
            dropdown.css('max-width', `${textField.width()}px`);
            dropdown.css('overflow-x', 'hidden');
        }
        proxy.on('click focus', () => {
            const firstVal = proxy.val();
            Bingo.PhoneField.setCountryCodeIfEmpty(proxy);
            Bingo.PhoneField.updateByProxy(proxy, $input);
            Bingo.TextField.labelUpCheck();

            //  For change caret position at end
            if (firstVal === '' || Bingo.PhoneField.hasOnlyCountryCode(proxy)) {
                Bingo.PhoneField.moveCursorToEnd(proxy);
            }
        });
        proxy.on('countrychange', () => {
            Bingo.PhoneField.setCountryCodeIfEmpty(proxy);
            Bingo.PhoneField.updateByProxy(proxy, $input);
            Bingo.TextField.labelUpCheck();
        });
        proxy.bind('keypress keyup change focus focusout', (e) => {
            if (e.type === 'change' || e.keyCode === 13) {
                Bingo.PhoneField.updateByProxy(proxy, $input);
                Bingo.TextField.labelUpCheck();
            }
        });
        $input.on('updateProxyValue', () => {
            proxy.val($input.val());
        });
    });
};

Bingo.PhoneField.setCountryCodeIfEmpty = ($input) => {
    const countryData = $input.intlTelInput('getSelectedCountryData');
    if ($input.val() === '') {
        $input.val(`+${countryData.dialCode}`);
    }
};

Bingo.PhoneField.removeCountryCodeIfEmpty = ($input) => {
    const countryData = $input.intlTelInput('getSelectedCountryData');
    if ($input.val() === `+${countryData.dialCode}`) {
        $input.val('');
    }
};

Bingo.PhoneField.updateByProxy = ($proxy, $input) => {
    const countryData = $proxy.intlTelInput('getSelectedCountryData');
    if ($proxy.val() === `+${countryData.dialCode}`) {
        $input.val('');
    } else {
        $input.val($proxy.intlTelInput('getNumber'));
    }
    $input.change();
};

Bingo.PhoneField.hasOnlyCountryCode = ($input) => {
    const countryData = $input.intlTelInput('getSelectedCountryData');
    return ($input.val() === `+${countryData.dialCode}`);
};

Bingo.PhoneField.moveCursorToEnd = ($input) => {
    // Double the length because Opera is inconsistent about whether a carriage return is one character or two.
    const len = $input.val().length * 2;

    // Timeout seems to be required for Blink
    setTimeout(() => {
        $input[0].setSelectionRange(len, len);
    }, 1);
};
